export default __webpack_public_path__ + "static/tiempos-text-web-regular-4d40a04bd1acb0e5e6820659b7907a0d.eot";